import { List } from '@chakra-ui/react';

export const ListRoot = List.Root;
export const ListItem = List.Item;
